// Couleurs de lecture du jeu (camps, équipes, zones) selon le mode de couleurs choisi dans les paramètres.
// Les zones gardent aussi leur numéro affiché sur la carte : la couleur n'est jamais le seul indice.
import { ZONE_COLORS } from '../../../shared/maps';
import { getSettings } from './settings';

export type ColorMode = 'standard' | 'redgreen' | 'blueyellow';

export interface ColorSet {
  self: number;
  ally: number;
  enemy: number;
  bot: number;
  monster: number;
  /** Barres de vie : soi, les autres. */
  hpSelf: number;
  hpOther: number;
  teams: [string, string];
  zoneFill: readonly number[];
  zoneRim: readonly number[];
}

const STANDARD: ColorSet = {
  self: 0x39d0ff,
  ally: 0x5cf08a,
  enemy: 0xff5a3c,
  bot: 0xffa24a,
  monster: 0xffb04a,
  hpSelf: 0x5cf08a,
  hpOther: 0xff6b57,
  teams: ['#39d0ff', '#ff7a5a'],
  zoneFill: ZONE_COLORS,
  zoneRim: [0x8d99a6, 0x4fd18a, 0xf0a04a, 0xff5a4a, 0xb48cff],
};

/** Deutéranopie et protanopie (rouge-vert, les plus fréquentes) : bleu contre jaune ambré, magenta pour le danger. */
const REDGREEN: ColorSet = {
  self: 0x39d0ff,
  ally: 0x3d7bff,
  enemy: 0xffb000,
  bot: 0xd98cff,
  monster: 0xffd27a,
  hpSelf: 0x4da3ff,
  hpOther: 0xffb000,
  teams: ['#3d8bff', '#ffb000'],
  zoneFill: [0x151a20, 0x2f63c4, 0xc9a227, 0xc23a7a, 0x6a3fc0],
  zoneRim: [0x8d99a6, 0x4d8dff, 0xffd23f, 0xff4fa0, 0x9d7bff],
};

/** Tritanopie (bleu-jaune) : sarcelle contre rouge rosé. */
const BLUEYELLOW: ColorSet = {
  self: 0x2ee6c8,
  ally: 0x1fb89f,
  enemy: 0xff3d6e,
  bot: 0xff8a8a,
  monster: 0xff9fb5,
  hpSelf: 0x2ee6c8,
  hpOther: 0xff3d6e,
  teams: ['#2ee6c8', '#ff3d6e'],
  zoneFill: [0x151a20, 0x1f8f7d, 0xd9667a, 0xb3122e, 0x4b2a6e],
  zoneRim: [0x8d99a6, 0x2ec4aa, 0xff8fa3, 0xff2a4f, 0x8a5cc4],
};

const SETS: Record<ColorMode, ColorSet> = { standard: STANDARD, redgreen: REDGREEN, blueyellow: BLUEYELLOW };

export function colors(): ColorSet {
  return SETS[getSettings().colorMode] ?? STANDARD;
}

export const css = (n: number) => `#${n.toString(16).padStart(6, '0')}`;
